import { Controller } from "@hotwired/stimulus"
import Chart from 'chart.js/auto'

export default class extends Controller {
  static targets = ["chart"]
  static values = {
    data: Array,
    type: String,
    assessmentId: Number
  }

  connect() {
  }

  disconnect() {
    this.destroyChart()
  }

  chartTargetConnected(target) {
    setTimeout(() => {
      this.initializeChartForTarget(target)
    }, 100)
  }

  chartTargetDisconnected(target) {
    const existingChart = Chart.getChart(target)
    if (existingChart) {
      existingChart.destroy()
    }
  }

  destroyChart() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  initializeChart() {
    if (!this.hasChartTarget) return

    this.destroyChart()

    const chartData = JSON.parse(this.chartTarget.dataset.radarChartDataValue || '[]')
    const chartType = this.chartTarget.dataset.radarChartTypeValue || 'sections'

    const labels = chartData.map(item => item.label)
    const values = chartData.map(item => item.value)

    const config = {
      type: 'radar',
      data: {
        labels: labels,
        datasets: [{
          label: chartType === 'sections' ? 'Moyenne pondérée' : 'Note moyenne',
          data: values,
          backgroundColor: 'rgba(59, 130, 246, 0.15)',
          borderColor: 'rgb(59, 130, 246)',
          borderWidth: 2.5,
          pointBackgroundColor: 'rgb(59, 130, 246)',
          pointBorderColor: '#fff',
          pointBorderWidth: 2,
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgb(59, 130, 246)',
          pointRadius: 5,
          pointHoverRadius: 7,
          pointHoverBorderWidth: 3
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        animation: {
          duration: 1000,
          easing: 'easeInOutQuart'
        },
        scales: {
          r: {
            beginAtZero: true,
            min: 0,
            max: 5,
            ticks: {
              stepSize: 1,
              backdropColor: 'transparent',
              color: '#6B7280',
              font: {
                size: 11,
                weight: '500'
              }
            },
            grid: {
              color: 'rgba(107, 114, 128, 0.1)',
              lineWidth: 1
            },
            angleLines: {
              color: 'rgba(107, 114, 128, 0.1)',
              lineWidth: 1
            },
            pointLabels: {
              color: '#374151',
              font: {
                size: 13,
                weight: '600'
              },
              padding: 10
            }
          }
        },
        plugins: {
          legend: {
            position: 'top',
            labels: {
              color: '#374151',
              font: {
                size: 13,
                weight: '500'
              },
              padding: 15,
              usePointStyle: true,
              pointStyle: 'circle'
            }
          },
          tooltip: {
            backgroundColor: 'rgba(17, 24, 39, 0.95)',
            titleColor: '#fff',
            bodyColor: '#E5E7EB',
            titleFont: {
              size: 13,
              weight: '600'
            },
            bodyFont: {
              size: 12,
              weight: '500'
            },
            padding: 12,
            cornerRadius: 8,
            displayColors: true,
            callbacks: {
              label: (context) => {
                const dataIndex = context.dataIndex
                const item = chartData[dataIndex]
                let label = `${context.dataset.label}: ${context.parsed.r.toFixed(2)}/5`

                if (item.weight && item.weight !== 1.0) {
                  label += ` (Poids: ×${item.weight})`
                }

                return label
              }
            }
          }
        },
        onClick: (event, elements) => {
          if (elements.length > 0 && chartType === 'sections') {
            const index = elements[0].index
            const sectionId = chartData[index].section_id
            this.loadSectionDetail({ currentTarget: { dataset: { sectionId } } })
          }
        }
      }
    }

    this.chart = new Chart(this.chartTarget, config)
  }

  async loadSectionDetail(event) {
    const sectionId = event.currentTarget.dataset.sectionId

    try {
      const response = await fetch(`/assessments/${this.assessmentIdValue}/section_radar?section_id=${sectionId}`, {
        headers: {
          'Accept': 'text/vnd.turbo-stream.html'
        }
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)

        setTimeout(() => {
          this.revealSectionDetail()
        }, 50)
      }
    } catch (error) {
      console.error('Error loading section detail:', error)
    }
  }

  revealSectionDetail() {
    const sectionDetail = document.getElementById('section-detail')
    const overlay = document.getElementById('section-detail-overlay')

    if (sectionDetail) {
      sectionDetail.style.display = 'block'
    }

    if (overlay) {
      overlay.style.display = 'block'
    }

    document.body.style.overflow = 'hidden'
  }

  initializeChartForTarget(canvasElement) {

    const chartData = JSON.parse(canvasElement.dataset.radarChartDataValue || '[]')
    const chartType = canvasElement.dataset.radarChartTypeValue || 'sections'
    if (!chartData || chartData.length === 0) {
      console.error('❌ No chart data available!')
      return
    }

    const labels = chartData.map(item => item.label)
    const values = chartData.map(item => item.value)


    const config = {
      type: 'radar',
      data: {
        labels: labels,
        datasets: [{
          label: chartType === 'sections' ? 'Moyenne pondérée' : 'Note moyenne',
          data: values,
          backgroundColor: 'rgba(59, 130, 246, 0.15)',
          borderColor: 'rgb(59, 130, 246)',
          borderWidth: 2.5,
          pointBackgroundColor: 'rgb(59, 130, 246)',
          pointBorderColor: '#fff',
          pointBorderWidth: 2,
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgb(59, 130, 246)',
          pointRadius: 5,
          pointHoverRadius: 7,
          pointHoverBorderWidth: 3
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        animation: {
          duration: 1000,
          easing: 'easeInOutQuart'
        },
        scales: {
          r: {
            beginAtZero: true,
            min: 0,
            max: 5,
            ticks: {
              stepSize: 1,
              backdropColor: 'transparent',
              color: '#6B7280',
              font: {
                size: 11,
                weight: '500'
              }
            },
            grid: {
              color: 'rgba(107, 114, 128, 0.1)',
              lineWidth: 1
            },
            angleLines: {
              color: 'rgba(107, 114, 128, 0.1)',
              lineWidth: 1
            },
            pointLabels: {
              color: '#374151',
              font: {
                size: 13,
                weight: '600'
              },
              padding: 10
            }
          }
        },
        plugins: {
          legend: {
            position: 'top',
            labels: {
              color: '#374151',
              font: {
                size: 13,
                weight: '500'
              },
              padding: 15,
              usePointStyle: true,
              pointStyle: 'circle'
            }
          },
          tooltip: {
            backgroundColor: 'rgba(17, 24, 39, 0.95)',
            titleColor: '#fff',
            bodyColor: '#E5E7EB',
            titleFont: {
              size: 13,
              weight: '600'
            },
            bodyFont: {
              size: 12,
              weight: '500'
            },
            padding: 12,
            cornerRadius: 8,
            displayColors: true,
            callbacks: {
              label: (context) => {
                const dataIndex = context.dataIndex
                const item = chartData[dataIndex]
                let label = `${context.dataset.label}: ${context.parsed.r.toFixed(2)}/5`

                if (item.weight && item.weight !== 1.0) {
                  label += ` (Poids: ×${item.weight})`
                }

                return label
              }
            }
          }
        }
      }
    }

    const existingChart = Chart.getChart(canvasElement)
    if (existingChart) {
      existingChart.destroy()
    }

    new Chart(canvasElement, config)
  }

  hideSectionDetail(event) {
    if (event) {
      event.stopPropagation()
    }

    const sectionDetail = document.getElementById('section-detail')
    const overlay = document.getElementById('section-detail-overlay')

    if (sectionDetail) {
      sectionDetail.style.opacity = '0'
      sectionDetail.style.transform = 'translate(-50%, -50%) scale(0.95)'

      setTimeout(() => {
        // Restaure le placeholder vide de results.html.erb au lieu de retirer
        // le nœud : la réouverture passe par `turbo_stream.replace "section-detail"`,
        // qui exige que la cible existe — un simple remove() rendait muette
        // toute réouverture après une première fermeture (open → close → open).
        const placeholder = document.createElement("div")
        placeholder.id = "section-detail"
        sectionDetail.replaceWith(placeholder)
      }, 200)
    }

    if (overlay) {
      overlay.style.opacity = '0'

      setTimeout(() => {
        overlay.remove()
      }, 200)
    }

    document.body.style.overflow = 'auto'
  }
}
